export default __webpack_public_path__ + "static/media/Medium's Belt of Secret Doors.3cfb5e3b.jpg";